export enum SalesConciergeStep {
   REQUEST_TYPE = 'REQUEST_TYPE',
   PRODUCT_COUNT_INFO = 'PRODUCT_COUNT_INFO',
   CUSTOMER_INFO = 'CUSTOMER_INFO',
   CUSTOMER_CONTACT_INFO = 'CUSTOMER_CONTACT_INFO',
   SEND_REQUEST = 'SEND_REQUEST'
}

